// src/auth/msalConfig.js
import { LogLevel } from '@azure/msal-browser';

const tenantId    = process.env.REACT_APP_ENTRA_TENANT_ID   ?? '';
const clientId    = process.env.REACT_APP_ENTRA_CLIENT_ID   ?? '';
const redirectUri = process.env.REACT_APP_ENTRA_REDIRECT_URI ?? window.location.origin;

export const msalConfig = {
  auth: {
    clientId,
    authority:             `https://login.microsoftonline.com/${tenantId || 'common'}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    // sessionStorage so a signed-out tab doesn't leave tokens sitting around longer
    // than the browser session, and multiple tabs don't silently share one session.
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error)                          console.error('[MSAL]', message);
        if (process.env.NODE_ENV === 'development' && level === LogLevel.Warning) console.warn('[MSAL]', message);
      },
    },
  },
};

// Option 1 architecture: single app registration, no "Expose an API" step, no custom scope.
// We request only the default OIDC scopes (openid/profile, added automatically by MSAL)
// and send the resulting ID token to the API.
//
// INTERACTIVE SIGN-IN ONLY. Use this for loginRedirect/loginPopup — never for token
// acquisition (see tokenRequest below).
//
// prompt: 'login' forces credential entry and negates single sign-on. Two reasons,
// both specific to the shared workstations these apps run on:
//
//   1. Many machines are signed into Windows with a generic departmental account
//      (MiamiGrocery@fhiworks.com and the like) so everyone can read the shared
//      mailbox. Without a prompt, Entra passes that device identity straight through
//      and the app authenticates as an account that has no security record — which
//      fails confusingly rather than cleanly.
//   2. 'select_account' would also interrupt SSO, but it lists every account with a
//      live session on that browser. On a machine a whole department shares, that
//      means a colleague's session is one unauthenticated click away, which defeats
//      the point of knowing who actually entered a record. 'login' can't be
//      satisfied by a click.
//
// Entra accepts only a SINGLE prompt value — 'login' and 'select_account' cannot be
// combined. See https://learn.microsoft.com/en-us/entra/identity-platform/msal-js-prompt-behavior
export const loginRequest = {
  scopes: [],
  prompt: 'login',
};

// TOKEN ACQUISITION ONLY. Use this for acquireTokenSilent/acquireTokenRedirect.
//
// Deliberately carries no prompt: a renewal that forced re-authentication would drag
// the user back through a full credential entry mid-shift every time a token aged out.
export const tokenRequest = {
  scopes: [],
};

export function isEntraConfigComplete() {
  return Boolean(tenantId && clientId);
}

export const entraConfigDiagnostics = { tenantId, clientId, redirectUri };
